var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"mt-7"},[_c('v-card',[_c('personnel-record-chronicle-data-table',{attrs:{"chronicleEvents":[],"mode":"view"}})],1)],1)])],1)],1)]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }